import dayjs from "dayjs";
const customParseFormat = require("dayjs/plugin/customParseFormat");

dayjs.extend(customParseFormat);

export const duration = (
  fromDate: string,
  toDate: string,
  days: boolean = true,
): string => {
  const date1: Date = new Date(fromDate);
  const date2: Date = new Date(toDate);

  const yearDiff: number = date2.getFullYear() - date1.getFullYear();
  const monthDiff: number = date2.getMonth() - date1.getMonth();
  const dayDiff: number = date2.getDate() - date1.getDate() + 1; // Including the same day as 1 day

  let totalMonths: number = yearDiff * 12 + monthDiff;
  let remainingDays: number = dayDiff;

  if (totalMonths > 0 && remainingDays < 0) {
    totalMonths--;
    remainingDays += new Date(
      date1.getFullYear(),
      date1.getMonth() + 1,
      0,
    ).getDate();
  }

  const yearsFromMonths = Math.floor(totalMonths / 12);
  const remainingMonths = totalMonths % 12;

  let result: string = "";

  if (yearsFromMonths > 0) {
    result += `${yearsFromMonths} Year${yearsFromMonths > 1 ? "s" : ""} `;
  }
  if (remainingMonths > 0) {
    result += `${remainingMonths} Month${remainingMonths > 1 ? "s" : ""} `;
  }
  if (remainingDays > 0 && days) {
    result += `${remainingDays} Day${remainingDays > 1 ? "s" : ""}`;
  }

  return fromDate && toDate ? result.trim() : "";
};

// export const duration = (
//   fromDate: string,
//   toDate: string,
//   days: boolean = true,
// ): string => {
//   const date1 = dayjs(fromDate);
//   const date2 = dayjs(toDate);

//   let daysDifference = date2.diff(date1, "day") + 1;
//   let monthsDifference = Math.floor(daysDifference / 30);
//   let yearsDifference = Math.floor(daysDifference / 365);
//   daysDifference %= 30;
//   monthsDifference %= 12;

//   let result = "";

//   if (yearsDifference > 0) {
//     result += `${yearsDifference} Year${yearsDifference > 1 ? "s" : ""} `;
//   }
//   if (monthsDifference > 0) {
//     result += `${monthsDifference} Month${monthsDifference > 1 ? "s" : ""} `;
//   }
//   if (daysDifference > 0) {
//     result += `${daysDifference} Day${daysDifference > 1 ? "s" : ""}`;
//   }

//   if (fromDate && toDate) return result;
//   else return "";
// };

export const calculateDaysDifference = (
  fromDate: string | Date | undefined,
  toDate: string | Date | undefined,
): number => {
  const date1 = dayjs(fromDate);
  const date2 = dayjs(toDate);

  const daysDifference = date2.diff(date1, "day") + 1;

  return daysDifference;
};

export const timeDuration = (
  startTimeString: string,
  endTimeString: string,
) => {
  // Split the time strings into hours, minutes, and seconds
  const startTimeParts = startTimeString?.split(":");
  const endTimeParts = endTimeString?.split(":");

  if (startTimeParts?.length !== 3 || endTimeParts?.length !== 3) {
    // return 'Invalid time format';
    return "";
  }

  const startHours = parseInt(startTimeParts[0]);
  const startMinutes = parseInt(startTimeParts[1]);
  const startSeconds = parseInt(startTimeParts[2]);

  const endHours = parseInt(endTimeParts[0]);
  const endMinutes = parseInt(endTimeParts[1]);
  const endSeconds = parseInt(endTimeParts[2]);

  if (
    isNaN(startHours) ||
    isNaN(startMinutes) ||
    isNaN(startSeconds) ||
    isNaN(endHours) ||
    isNaN(endMinutes) ||
    isNaN(endSeconds)
  ) {
    return "Invalid time values";
  }

  // Calculate the duration in seconds
  const durationInSeconds =
    (endHours - startHours) * 3600 +
    (endMinutes - startMinutes) * 60 +
    (endSeconds - startSeconds);

  if (durationInSeconds < 0) {
    return "End time cannot be earlier than start time";
  }

  // Calculate hours, minutes, and seconds
  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor((durationInSeconds % 3600) / 60);
  const seconds = durationInSeconds % 60;

  // Format the result as "hh:mm:ss"
  const formattedDuration = `${String(hours).padStart(2, "0")}:${String(
    minutes,
  ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  return formattedDuration;
};

export const convertDays = (
  days: number,
): { years: number; months: number; days: number } => {
  const years = Math.floor(days / 365);
  const months = Math.floor((days % 365) / 30);
  const remainingDays = (days % 365) % 30;

  return { years, months, days: remainingDays };
};

export const formatDuration = (duration: {
  years: number;
  months: number;
  days: number;
}): string => {
  const { years, months, days } = duration;
  const formattedDuration = [];

  if (years > 0) {
    formattedDuration.push(`${years} year${years > 1 ? "s" : ""}`);
  }

  if (months > 0) {
    formattedDuration.push(`${months} month${months > 1 ? "s" : ""}`);
  }

  if (days > 0) {
    formattedDuration.push(`${days} day${days > 1 ? "s" : ""}`);
  }

  return formattedDuration.join(" ");
};
